import React from 'react';
import { Button } from './VoteCta.styles';

export interface VoteCtaProps {
  label?: string;
  onClick?: () => void;
  disabled?: boolean;
}

/**
 * 투표하기 CTA 버튼 (feature)
 * 출처: spec §1-5. hover/pressed/disabled 는 디자인 미정의 →
 * 표준값 적용 (hover 시 약간 밝게, focus outline). 디자이너 확인 필요 (§4, §6-4).
 */
export function VoteCta({ label = '투표하기', onClick, disabled = false }: VoteCtaProps) {
  return (
    <Button type="button" onClick={onClick} disabled={disabled}>
      {label}
    </Button>
  );
}
